import type { RouteObject } from "react-router-dom";
import AccountPage, { sessionsLoader } from "./Account";
import AppError from "../app-error";

export const accountRoutes: RouteObject[] = [
  { path: "account", Component: AccountPage, loader: sessionsLoader, errorElement: <AppError /> },
];
